export default "__VITE_ASSET__CeJaPFUd__"